const styles = {
  buttonContainer: {
    display: "flex",
    justifyContent: "space-around",
    padding: 20,
  },
  cropButton: {
    display: "flex",
    alignItems: "stretch",
    cursor: "pointer"
  },
  changeButton: {
      cursor: "pointer"
  },
};

export default styles;
